<template>
    <div id="range-navigation" :class="['btn row', Classes().marginTop]" @click="ASSETS.Timeline.Navigation.ToSelection(this, $event)" v-if="show" @mouseleave="$emit('hide')">
        <div id="scrubber" class="btn flex-y-center" @mousedown="ASSETS.Timeline.Navigation.Grab(this, $event)" :style="`left: ${position}px; margin-left: ${marginLeft}px;`">
            <div id="arrow-left" class="arrow" v-if="showLeftArrow"></div>
            <div id="bar"></div>
            <div id="arrow-right" class="arrow" v-if="showRightArrow"></div>
        </div>
    </div>
</template>

<script>
import { CONFIG } from "@/assets/JS/Config.js";
import { ASSETS } from "@/assets/JS/Assets.js";
import $ from "jquery";

export default {
    name: "TimelineRangeNavigation",
    props: {
        timelineWidth: String,
        yBarExpanded: Boolean,
        show: Boolean,
        zoomControlEnabled: Boolean
    },
    data: () => ({
        position: 0,
        previousX: 0,
        CONFIG,
        showLeftArrow: false,
        showRightArrow: true,
        marginLeft: 0,
        ASSETS
    }),
    methods: {
        Scrub: function(target) {
            const { yBarWidth, navigation } = CONFIG.timeline;
            const startPosition = this.yBarExpanded ? yBarWidth.expanded : yBarWidth.collapsed;
            this.position = this.previousX - startPosition;
            this.previousX = target.clientX;

            // Timeline widths for scrubbing distance definition
            let navigationWidth = Number(Math.floor($("#range-navigation").width()));
            navigationWidth = navigationWidth - (navigation.scrubberWidth.instance - navigation.scrubberWidth.arrows);
            const timelinePixelWidth = Math.floor($("#timeline").width());
            const timelinePercentageWidth = Math.floor(Number(this.timelineWidth.replace("%", "")));
            let timelinePosition = Math.floor((this.previousX / timelinePixelWidth) * (timelinePercentageWidth - 100));

            // Manage scrubbing bounds; disallows control to extend past bounds of timeline
            const positionedLeft = this.position <= 10;
            const positionedRight = this.position >= navigationWidth - 10;
            if (positionedLeft) {
                this.position = 0;
                timelinePosition = 0;
            }
            if (positionedRight) {
                this.position = navigationWidth;
                timelinePosition = timelinePercentageWidth - 100;
            }
            this.showLeftArrow = !positionedLeft;
            this.showRightArrow = !positionedRight;
            this.SetScubberMargins(positionedLeft, positionedRight);

            this.$emit("navigate", timelinePosition);
        },

        // Scrubber arrows load/unload in view, so here we adjust margins to accommodate
        SetScubberMargins: function(positionedLeft, positionedRight) {
            const { arrows } = CONFIG.timeline.navigation.scrubberWidth;
            this.marginLeft = positionedLeft || positionedRight ? 0 : -arrows;
        },

        Classes: function() {
            return {
                marginTop: this.zoomControlEnabled ? "range-navigation-zoom-active" : ""
            };
        }
    },
    emits: [
        "navigate",
        "hide"
    ]
};
</script>